import type { ReactElement } from 'react';
import { Link } from 'react-router';

import { SURVEY_VIDEO_YOUTUBE_ID } from '@/shared/config';

type Props = {
  /** 이 영상이 설문 영상일 때만 그린다. */
  youtubeId: string;
  /** band = 자료실 카드 안의 띠, card = 영상 상세 옆 칸의 카드. */
  variant: 'band' | 'card';
};

/**
 * 설문 참여 안내 — 설문 영상 한 편에만 붙는다 (SURVEY_VIDEO_YOUTUBE_ID).
 *
 * 누르면 **같은 창에서** /survey 로 간다. 설문은 우리 사이트 안의 페이지라 새 탭을 열 이유가 없고,
 * 설문을 마치면 「자료실로 돌아가기」가 다시 데려온다.
 *
 * 버튼 글자를 짧게 두고 혜택은 옆 문장으로 뺀다 — 「설문 참여 & 프롬프트 받기」처럼 길면
 * 휴대폰에서 버튼이 두 줄로 깨진다.
 */
export function SurveyBanner({ youtubeId, variant }: Props): ReactElement | null {
  if (youtubeId !== SURVEY_VIDEO_YOUTUBE_ID) {
    return null;
  }

  const layout =
    variant === 'band'
      ? // 회색으로 두면 바로 아래 「이 영상의 자료 N개」 띠(회색)와 한 덩어리로 읽힌다 — 브랜드 색으로 가른다
        'flex flex-wrap items-center gap-x-4 gap-y-3 border-border border-t bg-primary/15 px-4 py-3.5'
      : 'flex flex-col gap-3 rounded-lg border border-foreground bg-card p-5';

  return (
    <div className={layout}>
      <p className="min-w-0 flex-1 text-[13.5px] leading-[1.7]">
        <span aria-hidden="true">🎁 </span>
        2~3분 설문에 참여하시면
        <br className={variant === 'band' ? 'sm:hidden' : undefined} />{' '}
        <strong className="font-semibold">GPT 지침 프롬프트</strong>를 메일로 보내드려요
      </p>
      <Link
        to="/survey"
        className="inline-flex h-10 shrink-0 items-center justify-center rounded-md bg-foreground px-4 text-[13.5px] font-medium text-background transition-opacity hover:opacity-85 focus-visible:outline-none focus-visible:ring-[3px] focus-visible:ring-primary"
      >
        설문 참여하기
      </Link>
    </div>
  );
}
